/**
 * Anonymous visitor key helpers.
 *
 * Provides a stable browser-local analytics identity for public flows while
 * remaining separate from authenticated sessions and refresh-cookie auth.
 */

const SHARED_VISITOR_KEY_STORAGE = 'heatcrafthp.anonymousVisitorKey';
const LEGACY_VISITOR_KEY_STORAGES = [
  'heatcrafthp.learningPathVisitorKey',
  'heatcrafthp.newsVisitorKey',
];

const createAnonymousVisitorKey = () => {
  const randomPart = Math.random().toString(36).slice(2, 12);
  return `anon_${Date.now()}_${randomPart}`;
};

/**
 * Get or create the shared anonymous visitor key used for public analytics.
 * Migrates legacy per-feature keys when present so existing browsers keep a
 * stable identity after the shared contract is introduced.
 *
 * @returns {string} Stable browser-local anonymous visitor key.
 */
export const getAnonymousVisitorKey = () => {
  try {
    let key = localStorage.getItem(SHARED_VISITOR_KEY_STORAGE);
    if (key) {
      return key;
    }

    for (const legacyStorageKey of LEGACY_VISITOR_KEY_STORAGES) {
      const legacyKey = localStorage.getItem(legacyStorageKey);
      if (legacyKey) {
        localStorage.setItem(SHARED_VISITOR_KEY_STORAGE, legacyKey);
        return legacyKey;
      }
    }

    key = createAnonymousVisitorKey();
    localStorage.setItem(SHARED_VISITOR_KEY_STORAGE, key);
    return key;
  } catch (error) {
    return createAnonymousVisitorKey();
  }
};

export default getAnonymousVisitorKey;